module.exports = __webpack_public_path__ + "static/media/family_07.aabf4947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_07.jpg
// module id = 5839
// module chunks = 0